<template>
  <custom-api-select
    :api="miniAppApi.list"
    :api-params="apiParams"
    :immediate="true"
    value-field="sub_appid"
    label-field="sub_app_name"
  />
</template>
<script lang="ts" setup>
import { miniAppApi } from '@/api/miniApp/miniApp'
import { miniappApiSelectProps } from './props'
const props = defineProps(miniappApiSelectProps)
const { apiParams } = props
</script>
